import React from "react"
import Local from "../base-pages/local"

const LocalEN = () => {
  return <Local lang="en" />
}

export default LocalEN
